import * as React from 'react';

const NoReplyIcon: React.FC<any> = (props: any) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9014 10V26H12.2613L6.45599 17.5938H6.36185V26H2V10H5.70287L11.4141 18.375H11.5396V10H15.9014Z"
      fill={props.htmlcolor}
    />
    <path
      d="M22.1383 26H17.4312L22.7345 10H28.6967L34 26H29.293L25.7784 14.4063H25.6529L22.1383 26ZM21.2596 19.6875H30.1089V22.9375H21.2596V19.6875Z"
      fill={props.htmlcolor}
    />
  </svg>
);

export default NoReplyIcon;
